import { find } from 'lodash'

// Vervang expressies. Alleen de eerste vraag wordt nog gebruikt.
export const replaceExpression = (text, answermap) => {
  let subst = answermap[1] || answermap[35] || "..."
  if (text) {
    if (text !== `${1}`) {
      // als de text niets anders bevat dan de te vervangen string, case hetzelfde laten.
      subst = subst.toLowerCase()
    }
    return text.replace(/\$\{1\}/g, subst)
  }
  return ''
}

export const makeFirstCharUppercase = (optionText) => {
  return optionText.charAt(0).toUpperCase() + optionText.slice(1);
}

export const handleNegativeInput = (e) => {
  const characterCode = e.key
  if (characterCode === 'Backspace' || (characterCode === 'Tab')) return
  const characterNumber = Number(characterCode)
  if (characterNumber >= 0 && characterNumber <= 9) {
    return null
  } else {
    e.preventDefault()
  }
}

export const handleKeyPress = (target, handlePost) => {
  if(target.charCode === 13) {
    target.preventDefault()
    handlePost()
  }
}

// Zoek het ingevulde antwoord (op dit moment alleen radio)
export const getAnswer = (questions, answers, questionId) => {
  var question = find(questions, q => q.id === questionId)
  var options = question.options
  var optionIds = options.map(o => o.id)
  var answer = find(answers, a => optionIds.indexOf(a.optionId) > -1 && a.booleanValue)
  if (answer) {
    return find(options, o => o.id === answer.optionId).optionText
  }
}

// Bouw een map van gegeven antwoord per vraag (op dit moment alleen radio)
export const buildAnswerMap = (questions, answers) => {
  const { genericQuestions } = questions
  var answerMap = {}

  genericQuestions.forEach(q => {
    var optionText = getAnswer(genericQuestions, answers, q.id)
    if (optionText) {
      answerMap[q.id] = optionText
    }
  })

  // Core questions zitten nog een niveau dieper. Deze worden op dit moment niet gebruikt voor expressies.

  // coreQuestions.forEach(cq => {
  //   const cqQuestions = cq.questions
  //   cqQuestions.forEach(q => {
  //     var optionText = getAnswer(cqQuestions, answers, q.id)
  //     if (optionText) {
  //       answerMap[q.id] = optionText
  //     }
  //   })
  // })
  return answerMap
}

export const isEmptyValue = (stringValue) => {
  return stringValue === undefined || stringValue === null || stringValue.length === 0
}



// WEBPACK FOOTER //
// ./src/utils/index.js